import { render, staticRenderFns } from "./regulations.vue.js?vue&type=template&id=83ec0e38!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./regulations.vue?vue&type=template&id=83ec0e38"
import script from "./regulations.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./regulations.vue?vue&type=script&lang=js"
export * from "./regulations.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./regulations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports